/**
 * 挂件曝光「已报过」缓存（模块级，与 WidgetHost 生命周期解耦）
 *
 * Host 挂在 (tabs)/layout，进 reader / pay 会卸载；组件 ref 会丢。
 * 用模块 Set 记住本页生命周期内已报过曝光的 activityId，避免回流 Tab 时
 * 把再次可见误判为 cold_start。
 *
 * - 写入：widget_retention_show 实际上报成功后 mark
 * - 清理：session 离开 SessionMap 时 prune，避免 activityId 复用误判
 * - 整页刷新自然清空（与冷启重新下发对齐）
 */

/** 本页内已成功上报过挂件曝光的 activityId */
const trackedShowIds = new Set<string>();

/**
 * 该活动是否已成功打过挂件曝光。
 * @param activityId 活动 id
 */
export function hasWidgetShowTracked(activityId: string): boolean {
    return trackedShowIds.has(activityId);
}

/**
 * 标记已成功上报挂件曝光。
 * @param activityId 活动 id
 */
export function markWidgetShowTracked(activityId: string): void {
    trackedShowIds.add(activityId);
}

/** 登录态切换时清空本页挂件曝光记录。 */
export function resetWidgetShowTracked(): void {
    trackedShowIds.clear();
}

/**
 * 只保留仍在 SessionMap 中的 id，去掉已失效活动。
 * @param aliveIds 当前 SessionMap 中的 activityId 集合
 */
export function pruneWidgetShowTracked(aliveIds: Set<string>): void {
    trackedShowIds.forEach(activityId => {
        if (!aliveIds.has(activityId)) {
            trackedShowIds.delete(activityId);
        }
    });
}
